import * as React from 'react';
import { ConfirmSignIn, Loading, TOTPSetup, VerifyContact } from 'aws-amplify-react';

import { LabSmartsConfirmSignUp } from './labsmarts-confirm-sign-up';
import { LabSmartsForgotPassword } from './labsmarts-forgot-password';
import { LabSmartsRequireNewPassword } from './labsmarts-require-new-password';
import { LabSmartsSignIn } from './labsmarts-sign-in';
import { LabSmartsSignUp } from './labsmarts-sign-up';

/**
 * Amplify feeds this object straight into each element's inline `style`, which
 * is the only way to reach its layout without depending on build-hashed CSS
 * module class names.
 *
 * The spacing is trimmed from Amplify's defaults because Create Account — the
 * tallest screen — scrolled on a laptop, pushing the Phone Number field below
 * the fold. Only the gaps change; the fields themselves keep their padding, so
 * nothing looks cramped. Vertical values are set as longhands so Amplify's own
 * `max-width: 599px` media query keeps supplying the narrower side padding.
 */
export const authTheme = {
  button: { backgroundColor: '#337ab7' },
  formSection: { paddingTop: '24px', paddingBottom: '24px' },
  sectionHeader: { marginBottom: '14px' },
  sectionBody: { marginBottom: '18px' },
  formField: { marginBottom: '14px' },
  // 16px of vertical padding gives Amplify a 55px-tall field; 12px gives 47px,
  // which still reads comfortably. The dial-code <select> is styled in CSS
  // rather than through the theme, so App.css mirrors this by hand.
  input: { marginBottom: '4px', padding: '12px 16px' },
};

export const signUpConfig = {
  hideAllDefaults: true,
  signUpFields: [
    {
      label: 'Email',
      key: 'username',
      required: true,
      placeholder: 'e.g. example@example.com',
      type: 'email',
      displayOrder: 1,
    },
    {
      label: 'Password',
      key: 'password',
      required: true,
      placeholder: 'Password',
      type: 'password',
      displayOrder: 2,
    },
    {
      label: 'First Name',
      key: 'given_name',
      required: true,
      placeholder: 'e.g. MaryAnn',
      displayOrder: 3,
    },
    {
      label: 'Last Name',
      key: 'family_name',
      required: true,
      placeholder: 'e.g. Marks',
      displayOrder: 4,
    },
    {
      label: 'Phone Number',
      key: 'phone_number',
      required: true,
      placeholder: 'e.g. 3115551212',
      displayOrder: 5,
    },
  ],
};

/**
 * Every screen the Authenticator can show.
 *
 * Supplying any custom component turns on the Authenticator's `hideDefault`,
 * so this list has to be complete — a screen left out here renders nothing at
 * all. Greetings is the deliberate exception: the sign-out header is off
 * (see `displaySignoutHeader` in SecureApp.tsx).
 *
 * authenticator-screens.test.tsx renders this exact array to guard that.
 */
export const authenticatorComponents = [
  <LabSmartsSignIn key="signIn" />,
  <ConfirmSignIn key="confirmSignIn" />,
  <LabSmartsRequireNewPassword key="requireNewPassword" />,
  <LabSmartsSignUp key="signUp" signUpConfig={signUpConfig} />,
  <LabSmartsConfirmSignUp key="confirmSignUp" />,
  <VerifyContact key="verifyContact" />,
  <LabSmartsForgotPassword key="forgotPassword" />,
  <TOTPSetup key="totpSetup" />,
  <Loading key="loading" />,
];
